import { FormikHelpers } from "formik";
import { useCreatePhoneCenter } from "./api/createPhoneCenter";
import PhoneCenterForm from "./PhoneCenterForm";
import { ICreatePhoneCenterForm } from "./phoneCenter";


const CreatePhoneCenter = ({handleCloseModal}: CreatePhoneCenterProps)  => {
  const createPhoneCenterMutation = useCreatePhoneCenter({data: {}});

  const initialValues: ICreatePhoneCenterForm = {
    description: "",
    unitID: "",
    phoneCentersSysModelId: "",
    phoneCentersMaintenanceId: "",
    incomingLines: "",
    outgoingLines: "",
    channelNumber: "",
    workstaions: "",
    elevatorNumber: "",
    fctNumber: "",
    errorCode: "",
    internalsNumber: "",
    comments: "",
    fileLink: "",
    isPSTN: false,
    isISDN: false,
    is30PRI: false,
    isLine: false,
    providers: [],
  };

  const handleSubmit = async (values: ICreatePhoneCenterForm, { setSubmitting }: FormikHelpers<ICreatePhoneCenterForm>): Promise<void> => {
    try {
      await createPhoneCenterMutation.mutateAsync({
        data: values,
      });
      handleCloseModal();
    } catch (error) {
      console.log(error);
      console.log("values", values);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <PhoneCenterForm initialValues={initialValues} type="create" onSubmit={handleSubmit} />
  )
}

interface CreatePhoneCenterProps {
  handleCloseModal: () => void;
}

export default CreatePhoneCenter;